import React, { Component } from 'react';
import Button from 'components/button';
import enhance from './enhance';

class Logout extends Component {
  render() {
    console.log('Is logged out, ', this.props.isLoggedOut);
    return (
      <div className="logout">
        <Button disabled={this.props.isLoggedOut} onClick={this.props.logout}>
          Logout
        </Button>
      </div>
    );
  }
}

export default enhance(Logout);



// WEBPACK FOOTER //
// ./src/components/logout/index.js